// extracted by mini-css-extract-plugin
module.exports = {"form-container":"dd31006766--form-container--nXiA8","title-container":"dd31006766--title-container--CoXon"};